import { createFileRoute, Outlet } from '@tanstack/react-router';
import { Suspense } from 'react';
import VStack from '@/components/Layout/VStack';
import { InboundDataPipelineDetailHeader } from './-layout/InboundDataPipelineDetailHeader';
export const Route = createFileRoute('/_staff/settings/data-connector/inbound/data-pipeline/$id/_pipeline-detail')({
  component: Layout
});
function Layout() {
  return <VStack>
      <Suspense>
        <InboundDataPipelineDetailHeader />
      </Suspense>
      <Outlet />
    </VStack>;
}